import React, { useEffect, useState } from 'react';
import { Dialog, Grid, IconButton, TextField, useMediaQuery, useTheme, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Close, Assignment } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FHEDivider from 'src/renderer/data/components/FHEDivider';
import { inelioSetDiagModeAction, inelioSetSlaveActuatorAction, inelioSetStageActuatorAction } from '../../../../../../../data/Products/actions';
import FHESwitch from '../../../../../../../../../data/components/FHESwitch';
import getMiddlewareSocketInstance from '../../../../../../../common/SocketMiddleware';
import Translator from '../../../../../../../../../../../translator';

const SLAVE_ACTU = 'getInelioSlaveActuators';
const STAGE_ACTU = 'getInelioStageActuators';
let refreshInterval = null;
let init = false;

const isCorrectSlave = (props, payload, code) => {
    return (
        props.fheCenter_mac === payload.fheCenter_mac && props.product_identifier === payload.product_identifier && code.slice(0, 2) === payload.slave
    );
};

const isCorrectStage = (props, payload, code) => {
    return props.fheCenter_mac === payload.fheCenter_mac && props.product_identifier === payload.product_identifier && code === payload.code;
};

const SLAVE_FIELDS = ['EV_3VC', 'EV_3VF', 'VECH'];
const STAGE_FIELDS = ['TKReact', 'CIR_C', 'CIR_F', 'Reacteur', 'EV_H2OC', 'EV_H2OF', 'EV_NH3'];

const initFields = fields => {
    return fields.reduce((acc, field) => {
        acc[field] = null;
        return acc;
    }, {});
};

const setFieldsState = (fields, state) => {
    return fields.reduce((acc, field) => {
        acc[field] = state;
        return acc;
    }, {});
};

function DiagnosticModal({ onClose, classes, code, ...props }) {
    const slave = code.slice(0, 2);
    const stage = code.slice(3, 5);
    const [timer, setTimer] = useState({ slave: 0, stage: 0 });
    const [disabledSlaveFields, setDisabledSlaveFields] = useState(setFieldsState(SLAVE_FIELDS, true));
    const [disabledStageFields, setDisabledStageFields] = useState(setFieldsState(STAGE_FIELDS, true));
    const [slaveActuators, setSlaveActuators] = useState(initFields(SLAVE_FIELDS));
    const [stageActuators, setStageActuators] = useState(initFields(STAGE_FIELDS));
    const [isDiagMode, setIsDiagMode] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        getMiddlewareSocketInstance()
            .on(SLAVE_ACTU, handleSlaveActuChange)
            .on(STAGE_ACTU, handleStageActuChange);
        return () => {
            clearInterval(refreshInterval);
            getMiddlewareSocketInstance() &&
                getMiddlewareSocketInstance()
                    .removeListener(SLAVE_ACTU, handleSlaveActuChange)
                    .removeListener(STAGE_ACTU, handleStageActuChange);
        };
    }, []);

    useEffect(() => {
        if (isDiagMode) {
            setDisabledStageFields(fields => ({ ...fields, ...setFieldsState(['EV_H2OC', 'EV_H2OF', 'EV_NH3'], false) }));
            refreshInterval = setInterval(() => {
                setTimer(timer => ({ slave: timer.slave + 1, stage: timer.stage + 1 }));
            }, 1000);
        } else {
            setTimer({ slave: 0, stage: 0 });
            clearInterval(refreshInterval);
        }
    }, [isDiagMode]);

    const handleSlaveActuChange = payload => {
        if (isCorrectSlave(props, payload, code)) {
            init = true;
            setSlaveActuators(payload.actuators);

            // setDisabledSlaveFields(setFieldsState(SLAVE_FIELDS, false));
            setDisabledSlaveFields(fields => ({ ...fields, ...setFieldsState([], false) }));

            setTimer(timer => ({ ...timer, slave: 0 }));
        }
    };
    const handleStageActuChange = payload => {
        if (isCorrectStage(props, payload, code)) {
            init = true;
            setStageActuators(payload.actuators);

            // setDisabledStageFields(setFieldsState(STAGE_FIELDS, false));
            setDisabledStageFields(fields => ({ ...fields, ...setFieldsState(['EV_H2OC', 'EV_H2OF', 'EV_NH3'], false) }));

            setTimer(timer => ({ ...timer, stage: 0 }));
        }
    };

    const handleSwitchMode = e => {
        const { checked } = e.target;
        const { fheCenter_mac, product_identifier } = props;
        inelioSetDiagModeAction({ fheCenter_mac, product_identifier, code, mode: checked ? 'DIAG' : 'STD' }).then(() => {
            setIsDiagMode(checked);
        });
    };

    const handleSwitchActuator = (e, key) => {
        const { checked } = e.target;
        if (SLAVE_FIELDS.includes(key)) {
            setSlaveActuators({ ...slaveActuators, [key]: checked });
            setDisabledSlaveFields({ ...disabledSlaveFields, [key]: true });
        } else {
            setStageActuators({ ...stageActuators, [key]: checked });
            //setDisabledStageFields({ ...disabledStageFields, [key]: true });
        }
        sendEvent(key, checked ? 1 : 0);
    };

    const handleChange = e => {
        const { value, name } = e.target;
        setStageActuators(actuators => ({ ...actuators, [name]: value }));
    };

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            const { name } = e.target;
            setDisabledStageFields({ ...disabledStageFields, [name]: true });
            return sendEvent(name, Number(stageActuators[name]));
        }
    };

    const sendEvent = (key, value) => {
        const { fheCenter_mac, product_identifier } = props;
        if (SLAVE_FIELDS.includes(key)) {
            return inelioSetSlaveActuatorAction({ fheCenter_mac, product_identifier, code: slave, actuator: key, state: value });
        } else {
            return inelioSetStageActuatorAction({ fheCenter_mac, product_identifier, code, actuator: key, state: value });
        }
    };

    return (
        <Dialog open onClose={onClose} maxWidth={false} fullScreen={fullScreen}>
            <Grid container className={classes.container}>
                <Grid container item xs={12}>
                    <Grid className={classes.title} container alignContent="center" item xs={11}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Assignment className={classes.icon} />
                        </div>
                        {Translator.translate('general.diagnostic')}
                    </Grid>
                    <Grid container alignItems="center" justify="center" item xs={1}>
                        <IconButton aria-label="close" className={classes.closeIcon} size="medium" onClick={onClose}>
                            <Close fontSize="inherit" />
                        </IconButton>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid container alignItems="center" justify="space-between" item xs={12}>
                        <Grid item>Activer le mode diagnostique</Grid>
                        <Grid item>
                            <FHESwitch color="primary" value={isDiagMode} onChange={handleSwitchMode} />
                        </Grid>
                    </Grid>
                    {isDiagMode && init && (
                        <Grid container alignItems="center" justify="space-between" item xs={12}>
                            <Grid item>Derniere mise a jour</Grid>
                            <Grid item>
                                Esclave: {timer.slave} sec - Etage: {timer.stage} sec
                            </Grid>
                        </Grid>
                    )}
                    <FHEDivider />
                    <Grid container alignItems="center" justify="space-between" item xs={12}>
                        <Grid item className={classes.subtitle}>
                            Esclave: {slave}
                        </Grid>
                    </Grid>
                    {Object.entries(slaveActuators).map(([key, value]) => {
                        return (
                            <Grid key={key} container alignItems="center" justify="space-between" item xs={12}>
                                <Grid item>{key} : </Grid>
                                <Grid item>
                                    <FHESwitch
                                        disabled={disabledSlaveFields[key] || !isDiagMode}
                                        checked={!!value || false}
                                        color="primary"
                                        onChange={e => handleSwitchActuator(e, key)}
                                    />
                                </Grid>
                            </Grid>
                        );
                    })}
                    <FHEDivider />
                    <Grid container alignItems="center" justify="space-between" item xs={12}>
                        <Grid item className={classes.subtitle}>
                            Etage: {stage}
                        </Grid>
                    </Grid>
                    {Object.entries(stageActuators).map(([key, value]) => {
                        return (
                            <Grid key={key} container alignItems="center" justify="space-between" item xs={12}>
                                <Grid item>{key} : </Grid>

                                <Grid item>
                                    {['TKReact', 'CIR_C', 'CIR_F'].includes(key) ? (
                                        <TextField
                                            disabled={disabledStageFields[key] || !isDiagMode}
                                            autoComplete="off"
                                            style={{ width: 50 }}
                                            name={key}
                                            value={value || ''}
                                            onChange={handleChange}
                                            onKeyPress={handleKeyPress}
                                            type="number"
                                        />
                                    ) : (
                                        <FHESwitch
                                            disabled={disabledStageFields[key] || !isDiagMode}
                                            checked={!!value || false}
                                            color="primary"
                                            onChange={e => handleSwitchActuator(e, key)}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </Dialog>
    );
}

const styles = theme => ({
    container: {
        maxWidth: 600,
        padding: 18,
    },
    title: {
        color: theme.palette.primary.main,
        fontSize: 34,
        fontWeight: 400,
        marginBottom: 12,
    },
    icon: {
        fontSize: '2rem',
        marginRight: 8,
    },
    item: {
        padding: 10,
    },
    saveIcon: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    subtitle: {
        color: theme.palette.primary.main,
        fontSize: 18,
    },
});

DiagnosticModal.propTypes = {
    fheCenter_mac: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    product_identifier: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
};
DiagnosticModal.defaultProps = {};

export default withRouter(
    connect(
        null,
        dispatch => bindActionCreators({ inelioSetDiagModeAction, inelioSetSlaveActuatorAction, inelioSetStageActuatorAction }, dispatch),
    )(withStyles(styles, { withTheme: true })(DiagnosticModal)),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19INL/components/DiagnosticModal.js